export const SiteTitle = '株式会社AIM ECサイト'